import { call, put, select, takeLatest } from "redux-saga/effects";

import menuData from "api/ui/menu";

import { SAVE_FILTERED_MENU, SAVE_USER_ROLES, SAVE_USER_MODULES } from "../actions/actionConstants";
import { checkPermissions } from "../utils/users";
import { filterMenuByModules, filterMenuByRoles } from "../utils/menuFilter";

// Cache the latest inputs so whichever action fires last can rebuild the full
// pipeline (module filter + role filter) deterministically.
let latestServices = null;

const selectUserRoles = (state) => state.getIn(["users", "user", "roles"]);

function* buildAndSaveMenu() {
  const userRoles = yield select(selectUserRoles);

  let filteredMenu;
  if (latestServices && latestServices.length > 0) {
    filteredMenu = yield call(filterMenuByModules, menuData, latestServices);
  } else {
    filteredMenu = menuData;
  }

  filteredMenu = yield call(filterMenuByRoles, filteredMenu, userRoles, checkPermissions);

  yield put({ type: SAVE_FILTERED_MENU, filteredMenu });
}

function* onUserRoles() {
  yield call(buildAndSaveMenu);
}

function* onUserModules(action) {
  try {
    latestServices = action.services || [];
    yield call(buildAndSaveMenu);
  } catch (error) {
    console.error("Error filtering menu by modules:", error);
    yield put({ type: SAVE_FILTERED_MENU, filteredMenu: [] });
  }
}

export default function* uiSaga() {
  yield takeLatest(SAVE_USER_ROLES, onUserRoles);
  yield takeLatest(SAVE_USER_MODULES, onUserModules);
}
